import { useFormikContext } from "formik";
import { useEffect } from "react";

export const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
        if (isSubmitting && !isValidating) {
            let keys = Object.keys(errors);
            if (keys.length > 0) {
                const errorElement = document.getElementsByClassName("c-error-message");
                if (errorElement?.length > 0) {
                    const element = errorElement[0] as HTMLElement;
                    element.scrollIntoView({ behavior: "smooth", block: "center" });
                    element.focus({ preventScroll: true });
                }
            }
        }
    }, [errors, isSubmitting, isValidating]);

    return null;
};
